/**
 * UTF-8 byte length, without `Buffer` and without `TextEncoder`.
 *
 * The 256 KB markdown cap is checked in two places, the API before parsing
 * and the editor before sending, so the measurement has to mean the same
 * thing in Node and in a browser. `Buffer` does not exist in one of them and
 * `TextEncoder` needs a DOM lib this package does not pull in, so the
 * arithmetic is written out. It is the standard UTF-8 encoding table: one byte
 * below U+0080, two below U+0800, four for a surrogate pair, three otherwise.
 */
export function utf8ByteLength(value) {
    let bytes = 0;
    for (let index = 0; index < value.length; index += 1) {
        const code = value.charCodeAt(index);
        if (code < 0x80) {
            bytes += 1;
        }
        else if (code < 0x800) {
            bytes += 2;
        }
        else if (code >= 0xd800 && code <= 0xdbff && index + 1 < value.length) {
            // High surrogate followed by its pair: one four-byte code point.
            bytes += 4;
            index += 1;
        }
        else {
            bytes += 3;
        }
    }
    return bytes;
}
//# sourceMappingURL=bytes.js.map